import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { Workbook } from "exceljs";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-invoice-report",
  templateUrl: "./invoice-report.component.html",
  styleUrls: ["./invoice-report.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class InvoiceReportComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  operatorsDisplayedColumns: string[] = [
    "OperatorId",
    // "Iframe",
    "GGR",
    "Commission",
    "Invoice",
    "Total",
    "Action",
  ];
  operators = new MatTableDataSource<any>();
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  monthYears: string[] = [];
  selectedMonthYear: string;
  startTime = 0;
  endTime = 0;
  expandedElement;
  manualAdjustData:any =[];
  operatorData = [];
  groupList = [];
  groupSettings: any = {};
  selectedGroup = new FormControl([]);
  duplicateData = [];

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.groupSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.populateMonthYears();
    this.getOperatorData();
  }

  ngAfterViewInit() {
    this.operators.sort = this.sort;
    this.operators.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'OperatorId': return item.operatorId;
        case 'GGR': return item.ggr;
        case 'Commission': return item.commission;
        case 'Invoice': return item.invoice;
        case "Total": return item.invoice - item.waiveAmount;
        default: return item[property];
      }
    };
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          const uniqueGroups = {};
          this.operatorData = res.operators;
            res.operators.map((operator) => {
              if (operator.group !== "") {
                uniqueGroups[operator.group] = true;
              }
            });
            this.groupList =  Object.keys(uniqueGroups);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onFilterChange() {
    if (this.selectedGroup.value.length != 0) {
      const operators = this.selectedGroup.value.length != 0 ? this.operatorData.filter(operator => operator.group === this.selectedGroup.value[0]).map(operator => operator.operator_id) : []
      this.operators.data = this.duplicateData.filter(operator => operators.includes(operator.operatorId))
    } else {
      this.operators.data = this.duplicateData
    }
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getReport() {
    let payload = {
      startDate: Math.floor(this.startTime / 1000),
      // endDate: Math.floor(this.endTime / 1000),
    };
    try {
      this.appService.invoiceReport(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.operators.data = res.operators;
          // this.operators = new MatTableDataSource<any>(res.report);
          // this.operators.paginator = this.paginator;
          var result = [];
          var helper = {};
          if (res.report) {
            result = res.report.reduce(function (r, o) {
              var key = o.operatorId;

              if (!helper[key]) {
                helper[key] = Object.assign({}, o); // create a copy of o
                helper[key]["sub"] = [Object.assign({}, o)];
                helper[key].ggr = o.ggr;
                helper[key].commission = o.commission;
                helper[key].invoice = o.invoice;
                helper[key].monthDate = o.monthDate;
                helper[key].waiveAmount = o.waiveAmount;
                helper[key].reason = o.reason;
                r.push(helper[key]);
              } else {
                helper[key].monthDate = o.monthDate;
                helper[key].waiveAmount = o.waiveAmount;
                helper[key].reason = o.reason;
                helper[key].commission = o.commission;
                helper[key].ggr += o.ggr;
                helper[key].invoice += o.invoice;
                helper[key]["sub"].push(o);
              }
              var helper2 = {};
              helper[key]["sub"] = helper[key]["sub"].reduce(function (r2, o2) {
                if (o2) {
                  var key2 = o2.iframe;
                  if (!helper2[key2]) {
                    helper2[key2] = Object.assign({}, o2); // create a copy of o
                    r2.push(helper2[key2]);
                  } else {
                    helper2[key2].iframe = o2.iframe;
                    helper2[key2].ggr += o2.ggr;
                    helper2[key2].invoice += o2.invoice;
                  }
                }
                return r2;
              }, []);
              return r;
            }, []);
          }
          this.duplicateData = result;
          this.operators.data = result;
          this.operators.paginator = this.paginator;
          // this.selectedGroup.setValue([]);
          this.onFilterChange();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getTotalValue(column: string) {
    return this.operators.filteredData
      .map((t) => t[column])
      .reduce((acc, value) => acc + value, 0);
  }

  onExpand(element) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  categorizedData = {};
  getExportExcel() {
    if (this.selectedGroup.value.length != 0) {
      this.categorizedData = {};
      let data = {};
      let waiveAmount = 0;
      let monthDate = "";
      this.operators.data.forEach(operator => {
        monthDate = operator.monthDate;
        waiveAmount += operator.waiveAmount
        operator.sub.forEach(iframeObj => {
          const { iframe, waiveAmount, commission, ggr, invoice, monthDate, operatorId, reason } = iframeObj;
      
          if (this.categorizedData[iframe]) {
            if (iframe == "FEED") {
              this.categorizedData[iframe].commission += commission;
            } else {
              this.categorizedData[iframe].commission = commission;
            }
            
            this.categorizedData[iframe].ggr += ggr;
            this.categorizedData[iframe].invoice += invoice;
            this.categorizedData[iframe].monthDate = monthDate;
            this.categorizedData[iframe].operatorId = operatorId;
            this.categorizedData[iframe].reason = reason;
          } else {
            this.categorizedData[iframe] = { 
              iframe, 
              waiveAmount, 
              commission, 
              ggr, 
              invoice, 
              monthDate,
              operatorId,
              reason
            };
          }
        });
      });
      const categorizedArray : any = Object.values(this.categorizedData);
      const feedIndex = categorizedArray.findIndex(item => item.iframe === "FEED");
      if (feedIndex !== -1) {
        const feedObject = categorizedArray.splice(feedIndex, 1)[0];
        categorizedArray.push(feedObject);
      }
      this.manualAdjustData.amount = waiveAmount;
      data = {
        waiveAmount:waiveAmount,
        monthDate:monthDate,
        sub:categorizedArray
      }
      this.excel(data,false);
      this.manualAdjustData = [];
    } else {
      this.operators.data.forEach((operator) => {
        this.excel(operator,false);
      });
    }
  }

  excel(value, individual) {
    const element = value.sub;
    const currentDate = new Date(value.monthDate * 1000);
    const invoicedate = new Date();
    const formattedDate =
      currentDate.getFullYear().toString() +
      ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const InvDate = invoicedate.toISOString().split("T")[0];

    const workbook = new Workbook();
    const addDataToWorksheet = (
      worksheet,
      title,
      columnHeaders,
      columnKeys,
      columnWidths,
      data
    ) => {
      if (worksheet.name === "Invoice") {
        const row1 = worksheet.addRow([
          "Invoice Number",
          "INV-" + formattedDate,
        ]);
        row1.getCell(1).font = { bold: true };
        row1.getCell(2).alignment = { horizontal: "right" };

        const row2 = worksheet.addRow(["Invoice Date", InvDate]);
        row2.getCell(1).font = { bold: true };
        row2.getCell(2).alignment = { horizontal: "right" };

        const dueDate = new Date(invoicedate);
        dueDate.setDate(dueDate.getDate() + 7);
        const formattedDueDate = dueDate.toISOString().slice(0, 10);
        const row3 = worksheet.addRow(["Due Date", formattedDueDate]);
        row3.getCell(1).font = { bold: true };
        row3.getCell(2).alignment = { horizontal: "right" };

        worksheet.addRow([]);
      }

      const titleRow = worksheet.addRow([title]);
      titleRow.eachCell((cell) => {
        cell.alignment = { horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "B4C6E7" },
        };
      });
      worksheet.mergeCells(
        `A${titleRow.number}:${String.fromCharCode(
          65 + columnHeaders.length - 1
        )}${titleRow.number}`
      );

      const headerRow = worksheet.addRow(columnHeaders);
      headerRow.eachCell((cell) => {
        cell.alignment = { horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "B4C6E7" },
        };
        cell.border = {
          bottom: { style: "thin" },
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      worksheet.columns = columnKeys.map((key, index) => ({
        key,
        width: columnWidths[index],
      }));

      data.forEach((rowData) => {
        // const row = worksheet.addRow(rowData);
        const rowValues = columnKeys.map((key) => {
          if (!isNaN(rowData[key])) {
            return parseFloat(rowData[key]).toFixed(2);
          }
          return rowData[key];
        });

        const row = worksheet.addRow(rowValues);
        row.eachCell((cell) => {
          cell.border = {
            bottom: { style: "thin" },
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
      if (worksheet.name === "Invoice") {
        const platformFeeIndex = invoiceColumnHeaders.indexOf("Platform Fee");
        const platformFeeTotal = invoiceData.reduce((total, rowData) => {
          return (
            total + parseFloat(rowData[invoiceColumnKeys[platformFeeIndex]])
          );
        }, 0);
        let points = this.manualAdjustData.amount;
        if (!points) {
          points = 0;
        }
        const totalPlatformFeeWithManualAdjustment = platformFeeTotal.toFixed(2) - points;
        let cellNo: any;
        let endrow1 : any;
        let endrow2 : any;
        if (element[0].iframe == "FEED") {
          cellNo = 2;
          endrow1 = worksheet.addRow(["", "Manual Adjustments", points]);
          endrow2 = worksheet.addRow(["", "Total", totalPlatformFeeWithManualAdjustment]);
        } else {
          cellNo = 3;
          endrow1 = worksheet.addRow(["", "", "Manual Adjustments", points]);
          endrow2 = worksheet.addRow(["", "", "Total", totalPlatformFeeWithManualAdjustment]);
        }
        endrow1.getCell(cellNo).font = { bold: true };
        endrow1.getCell(cellNo).border = {
          bottom: { style: "thin" },
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        endrow1.getCell(cellNo+1).alignment = { horizontal: "left" };
        endrow1.getCell(cellNo+1).border = {
          bottom: { style: "thin" },
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        
        endrow2.getCell(cellNo).font = { bold: true };
        endrow2.getCell(cellNo).border = {
          bottom: { style: "thin" },
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        endrow2.getCell(cellNo+1).alignment = { horizontal: "left" };
        endrow2.getCell(cellNo+1).border = {
          bottom: { style: "thin" },
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      }
    };

    element.forEach(item => {
      if (item.iframe !== "FEED") {
        item.commission = `${item.commission}%`;
      }
    });
    const invoiceData = element;
    const manualAdjustmentData = Array.isArray(this.manualAdjustData) ? this.manualAdjustData : [this.manualAdjustData];
    const selectedMonth = this.selectedMonthYear;

    const invoiceWorksheet = workbook.addWorksheet("Invoice");

    let invoiceColumnHeaders = [
      "Service",
      "GGR",
      "Commission",
      "Platform Fee",
    ];
    const manualAdjustmentHeaders = ['Manual Adjust Reason', 'Amount'];
    let selectedOperator = element[0].operatorId;
    let invoiceColumnKeys = ["iframe", "ggr", "commission", "invoice"];
    const manualAdjustmentColumnKeys = ['reason', 'amount'];

    let invoiceColumnWidths = [15, 15, 20, 15];
    const manualAdjustmentWidths = [20, 20];
    if (element[0].iframe == "FEED") {
      invoiceColumnHeaders = [
        "Service",
        "Commission",
        "Platform Fee",
      ];
      invoiceColumnKeys = ["iframe", "commission", "invoice"];
      invoiceColumnWidths = [15, 20, 15];
    }

    const invoiceTitle = `Invoice`;
    addDataToWorksheet(
      invoiceWorksheet,
      invoiceTitle,
      invoiceColumnHeaders,
      invoiceColumnKeys,
      invoiceColumnWidths,
      invoiceData
    );
    if (this.selectedGroup.value.length == 0 || individual) {
      const manualAdjustmentWorksheet = workbook.addWorksheet('Manual Adjustments');
      addDataToWorksheet(manualAdjustmentWorksheet, 'Manual Adjustments', manualAdjustmentHeaders, manualAdjustmentColumnKeys, manualAdjustmentWidths, manualAdjustmentData);
    } else {
      selectedOperator = this.selectedGroup.value[0];
    }

    const filename = `Invoice_${selectedOperator}_${selectedMonth}.xlsx`;

    workbook.xlsx.writeBuffer().then((excelBuffer) => {
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    });
  }

  populateMonthYears() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    let startingMonthIndex = currentMonth - 4;
    let startingYear = currentYear;
    if (startingMonthIndex < 0) {
      startingMonthIndex += 12;
      startingYear -= 1;
    }

    this.monthYears = [];

    for (let i = 0; i < 4; i++) {
      const monthIndex = (startingMonthIndex + i) % 12;
      const year = startingYear + Math.floor((startingMonthIndex + i) / 12);
      const monthYear = `${this.getMonthName(monthIndex)} ${year}`;
      this.monthYears.push(monthYear);
    }
    this.monthYears.reverse();
  }

  getMonthName(monthIndex: number): string {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthIndex];
  }

  selectionChanged(event) {
    this.selectedMonthYear = event.value;
    const [selectedMonth, selectedYear] = this.selectedMonthYear.split(" ");
    const yearNumber = parseInt(selectedYear, 10);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const startDate = new Date(yearNumber, months.indexOf(selectedMonth), 1);
    const endDate = new Date(
      yearNumber,
      months.indexOf(selectedMonth) + 1,
      0,
      23,
      59,
      59
    );

    this.startTime = startDate.getTime();
    this.endTime = endDate.getTime();
  }

  searchOperator(event) {
    const value = event.target.value;
    this.operators.filter = value.trim().toLocaleLowerCase();
  }

  editCommission = (element) => {
    let dialogRef = this.dialog.open(UpdateReportCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Update Service Commission",
        operatorId: element.operatorId,
        commission: element.commission,
        iframe: element.iframe,
        monthDate: element.monthDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getReport();
      }
    });
  };

  editAllCommission = (element) => {
    let dialogRef = this.dialog.open(UpdateReportCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Update Commission",
        operatorId: element.operatorId,
        operator: true,
        monthDate: element.monthDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getReport();
      }
    });
  };

  openDialog(element) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "yes") {
        this.manualAdjustment(element)
      }else if (result == "no"){
        this.excel(element,true);
      }
    });
  }
  manualAdjustment = (element) => {
    let dialogRef = this.dialog.open(ManualAdjustment, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        reason: element.reason,
        amount: element.waiveAmount,
        date: element.monthDate,
        operatorId: element.operatorId,
        fees: element.invoice.toFixed(2),
      },
    });
    // this.manualAdjustData.Reason = element.reason
    // this.manualAdjustData.WaiveAmount = element.amount
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.manualAdjustData = response.value;
        // this.manualAdjustData.Reason = response.value.reason;
        // this.manualAdjustData.WaiveAmount = response.value.amount;
        this.excel(element,true);
        this.manualAdjustData = [];
        this.getReport();
      }
    });
  };
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./confirm-dialog.html",
  styleUrls: ["./invoice-report.component.scss"],
})
export class ConfirmDialogComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    ) { }

  onNoClick(): void {
    this.dialogRef.close("no");
  }

  onYesClick(): void {
    this.dialogRef.close("yes");
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./manual-adjustment.html",
  styleUrls: ["./invoice-report.component.scss"],
})
export class ManualAdjustment {
  manualadj: FormGroup;
  selected = new FormControl();
  operatorData = [];
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<ManualAdjustment>,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data = this.Data;
  check = !this.data.add;

  ngOnInit() {
    this.manualadj = new FormGroup({
      reason: new FormControl(this.data.reason, Validators.required),
      amount: new FormControl(this.data.fees, Validators.required),
    });
  }

  confirm() {
    if (this.manualadj.value.amount > this.data.fees) {
      this.appService.openErrorBar("Adjustment is wrong");
      return;
    }
    this.manualadj.value.amount = this.data.fees - this.manualadj.value.amount;
    const payload = {
      operatorId: this.data.operatorId,
      monthDate: this.data.date,
      waiveAmount: this.manualadj.value.amount,
      reason: this.manualadj.value.reason,
    };
    try {
      this.appService.updateWaiveAmount(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close(this.manualadj);
        } else {
          this.dialogRef.close();
        }
      });
    } catch (err) {}
    // this.dialogRef.close(this.manualadj);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./update-report-commission.html",
  styleUrls: ["./invoice-report.component.scss"],
})
export class UpdateReportCommission {
  reportcommission: FormGroup;

  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<UpdateReportCommission>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data = this.Data;
  check = !this.data.add;

  ngOnInit() {
    this.reportcommission = new FormGroup({
      operatorId: new FormControl(this.data.operatorId),
      iframe: new FormControl(this.data.iframe),
      commission: new FormControl(this.data.commission, Validators.required),
    });
  }

  confirm() {
    const payload = {
      operatorId: this.data.operatorId,
      iframe: this.data.iframe,
      monthDate: this.data.monthDate,
      commission: this.reportcommission.value.commission,
    };
    try {
      this.appService.updateReportCommission(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("Updated Successfully");
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
        }
      });
    } catch (err) {}
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
